import { jsx as o } from "react/jsx-runtime";
const e = ({
  width: r,
  height: t,
  className: i
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: i,
    height: t,
    viewBox: "0 0 7 14",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o("g", { id: "Group 26086295", children: /* @__PURE__ */ o(
      "path",
      {
        d: "M6.88208 5.24289H3.62438L6.47278 0.5H2.89242L0.5 7.20696H3.47237L1.66231 13.2642L6.88208 5.24289Z",
        fill: "currentColor",
        id: "Path 33733"
      }
    ) })
  }
);
export {
  e as Content
};
